import React from 'react';
import { Box, List, ListItem, Button, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { useUser } from '../../../Context/User';
import { useNavigate } from 'react-router-dom';
import DarkModeToggle from './DarkModeToggle'; // Import the DarkModeToggle component

const ProfileOptionsDrawer = () => {
  const navigate = useNavigate(); // Instantiate the useNavigate hook
  const { logout } = useUser();
  const textColor = useColorModeValue('black', 'white'); // Get the text color based on the
  // Define common styles for text to ensure consistency
  const textStyle = {
    fontSize: 'md',
    fontWeight: 'medium',
  };

  return (
    <Box>
      <List spacing={3}>
        <ListItem>
          <Flex alignItems="center" justifyContent="space-between">
            <Text {...textStyle}>Dark Mode</Text>
            <DarkModeToggle />
          </Flex>
        </ListItem>
        <ListItem>
          <Button variant="ghost" onClick={() => navigate('/settings')} {...textStyle} color={textColor}>
            Settings
          </Button>
        </ListItem>
        <ListItem>
          <Button variant="ghost" onClick={logout} {...textStyle} color={textColor}>
            Logout
          </Button>
        </ListItem>
      </List>
    </Box>
  );
};

export default ProfileOptionsDrawer;
